import { PermanentShopEnum } from 'types/types';

export const asPermanentShopEnum = (
  shopId: string
): PermanentShopEnum | undefined =>
  Object.values(PermanentShopEnum).find(id => id === shopId) ?? undefined;
